import React, { memo, FC } from 'react'
import LetUsKnowCard from './LetUsKnowCard'

interface Iprops {
  label: string
  children: any
  isItemsGrouped?: boolean
}
const ToolsWrapper: FC<Iprops> = ({ label, children, isItemsGrouped }) => {
  return (
    <div>
      <div className="col-span-12 bg-white">
        <div className="xs:bock  grid-cols-12  xs:px-[10px] xs:pt-[46px] xs:pb-[10px]  sm:pl-[50px] md:pt-14 mdl:px-[50px] lg:pb-[24px] mdl:mb-[24px] lg:mb-[37px] gap-12 mdl:pb-6 sm:pt-14  lg:pt-14 xl:pb-10">
          <div className="sm:flex justify-between items-center w-full pb-12">
            <p className="text-2xl font-light">{label} Tools</p>
            <div className="hidden sm:block">
              <LetUsKnowCard />
            </div>
          </div>

          <div
            className={`${
              isItemsGrouped ? 'block' : 'flex'
            } xs:items-start xs:justify-center sm:justify-start xs:gap-6 sm:gap-12 lg:gap-10 xs:flex-wrap min-h-[320px] overflow-y-auto pb-4`}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(ToolsWrapper)
